import { render, staticRenderFns } from "./pim-header.vue?vue&type=template&id=4bb35328&"
import script from "./pim-header.vue?vue&type=script&lang=js&"
export * from "./pim-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports